import PDFPreview from './PDFPreview';

export default PDFPreview;
